import * as React from 'react';
import { CalendarClock } from 'lucide-react';
import type { MeetingAnalytics } from '../types';
import { dateTimeOrDash } from '../format';
import { Section } from './Section';

/** Scheduled vs. actual start/end — side by side so "started late / ran over"
 *  reads at a glance. Each value is a formatted stamp or "—" (never blank). */
export function TimingCard({ data }: { data: MeetingAnalytics }) {
  return (
    <Section title="Timing" icon={<CalendarClock className="h-4 w-4" aria-hidden="true" />}>
      <div className="grid gap-x-8 gap-y-6 sm:grid-cols-2">
        <TimingColumn
          heading="Scheduled"
          start={dateTimeOrDash(data.scheduledStart)}
          end={dateTimeOrDash(data.scheduledEnd)}
        />
        <TimingColumn
          heading="Actual"
          start={dateTimeOrDash(data.actualStart)}
          end={dateTimeOrDash(data.actualEnd)}
        />
      </div>
    </Section>
  );
}

function TimingColumn({ heading, start, end }: { heading: string; start: string; end: string }) {
  return (
    <div>
      <p className="mb-2 text-[0.6875rem] font-semibold uppercase tracking-[0.06em] text-[var(--text-muted)]">
        {heading}
      </p>
      <dl className="divide-y divide-[var(--border)]">
        <DefRow label="Start" value={start} />
        <DefRow label="End" value={end} />
      </dl>
    </div>
  );
}

function DefRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-baseline justify-between gap-4 py-2 first:pt-0 last:pb-0">
      <dt className="shrink-0 text-sm text-[var(--text-muted)]">{label}</dt>
      <dd className="text-right text-sm font-medium text-[var(--text-primary)]">{value}</dd>
    </div>
  );
}
